import { HabitSchedule, Timestamp } from '@griply/types';

import { getDisplayEndDate } from './get-display-end-date';
import { getLastSchedule } from './get-last-schedule';
import { isHabitEnded } from './is-habit-ended';

// the display end date of an ended habit's last schedule; null while still active
export const getHabitEndedDate = (
  schedules: HabitSchedule[],
  today: Timestamp,
): Date | null =>
  isHabitEnded(schedules, today)
    ? getDisplayEndDate(getLastSchedule(schedules)?.endDate)
    : null;
